/* global SmartOrderRefillSettings */
/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

const sorHelpers = require('../sorHelpers/sorHelpers');

const linkModalYes = function (url, $orderList, e) {
  if (!e.detail || e.detail === 1) {
    // cover the confirmation modal so the request can't be fired twice
    const $loaderHost = sorHelpers.sorLoader.getModalHost($(this));
    sorHelpers.sorLoader.start($loaderHost);
    // the order list (if the action comes from there) stays locked until the page is reloaded
    sorHelpers.sorLoader.start($orderList);
    const stopLoaders = function () {
      sorHelpers.sorLoader.stop($loaderHost);
      sorHelpers.sorLoader.stop($orderList);
    };
    $.ajax({
      type: 'GET',
      url: url,
      success: function (response) {
        if (response.success) {
          if (response.toastMessage) {
            try {
              sessionStorage.setItem('sorToastMessage', response.toastMessage);
            } catch (error) {
              window.location.href = SmartOrderRefillSettings.Urls.manageOrders;
            }
          }
          window.location.href = SmartOrderRefillSettings.Urls.manageOrders;
        } else if (response.message) {
          stopLoaders();
          sorHelpers.sorModal.initWarningModal(response.message);
        } else {
          stopLoaders();
          sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR, true);
        }
      },
      error: function (err) {
        if (err.responseJSON && err.responseJSON.redirectURL) {
          window.location.href = err.responseJSON.redirectURL;
        } else {
          stopLoaders();
          sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR, true);
        }
      }
    });
  }
};

const initLinkModal = function () {
  $(document)
    .off('click', '.sorshowmodal')
    .on('click', '.sorshowmodal', function (e) {
      e.preventDefault();
      const $trigger = $(this);
      const $orderList = $trigger.closest('.subscriptionOrders');
      if ($orderList.hasClass('sor-loader-host') || $trigger.children('.veil').length) {
        return;
      }
      // feedback until the modal is visible: loader over the order list or inside the (btn-loader) button
      const stopTriggerLoader = function () {
        if ($orderList.length) {
          sorHelpers.sorLoader.stop($orderList);
        } else {
          $trigger.spinner().stop();
        }
      };
      if ($orderList.length) {
        sorHelpers.sorLoader.start($orderList);
      } else {
        $trigger.spinner().start();
      }
      const url = $trigger.attr('data-link');
      const title = $(this).attr('data-title');
      const content = $(this).attr('data-content');
      const yes = $(this).attr('data-yes');
      const no = $(this).attr('data-no');
      const $container = sorHelpers.sorModal.createContainer('#link-model');
      const options = {
        autoOpen: true,
        modal: true,
        title: title,
        width: '25rem',
        buttons: {}
      };

      if (yes) {
        options.buttons[yes] = linkModalYes.bind($container, url, $orderList);
      }
      if (no) {
        options.buttons[no] = sorHelpers.sorModal.closeModal;
      }
      $container.html('<h3 class="text-center">' + content + '</h3>');

      sorHelpers.sorModal.createModal($container, options);
      sorHelpers.sorModal.onShown($container, stopTriggerLoader);
    });
};

module.exports = {
  initLinkModal: initLinkModal
};
